<script lang="ts">
  import { CodeBlock } from "$ui/code-block";
  import { CODE_BLOCKS_INSTALL, CODE_BLOCKS_SDK_INIT } from "$utils/constants";
  import "highlight.js/styles/github.css";
  import ApiKeyHelper from "./ApiKeyHelper.svelte";

  let data_sources: [] = [];
  let exampleKey = "test_1234567";
  let hideGenerateKey = false;

  $: codeBlocks = CODE_BLOCKS_SDK_INIT(data_sources, exampleKey);

  let onSuccess: (values: any) => Promise<void>;

  const handleSubmit = async () => {
    onSuccess && (await onSuccess());
  };

  export { data_sources, app_id, hideGenerateKey, handleSubmit, onSuccess };
</script>

<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-6">
    <ApiKeyHelper {hideGenerateKey} />
    <div class="flex flex-col gap-4">
      <div>
        <h3 class="font-semibold">Install package</h3>
        <p>Run this command to install the latest version of our SDK for your backend application.</p>
      </div>
      <CodeBlock blocks={CODE_BLOCKS_INSTALL} />
    </div>
    <div class="flex flex-col gap-4">
      <div>
        <h3 class="font-semibold">Initialize SDK client</h3>
        <p>Then, initialize your client with Permissions Assurance using your app key.</p>
      </div>
      <CodeBlock blocks={codeBlocks} />
    </div>
  </div>
</div>
